import styled from '@emotion/styled';
import React from 'react';
import { useTranslation } from 'react-i18next';

type P = {
  onClick: () => void;
};

const AutoAlert = ({ onClick }: P) => {
  const { t } = useTranslation();
  return (
    <BubbleContainer>
      <BubbleTail />
      <Message>
        {t('메모가 비어있어\nAI가 작성한 내용을 바로 채워드렸어요!')}
      </Message>
      <ConfirmButton
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
      >
        {t('확인')}
      </ConfirmButton>
    </BubbleContainer>
  );
};

export default AutoAlert;

const BubbleContainer = styled.div`
  position: relative;
  background-color: #000;
  color: white;
  border-radius: 12px;
  padding: 16px;
  width: fit-content;
  max-width: 300px;
  margin-left: 12px; /* 꼬리 여백 확보 */
  z-index: 1;
`;

const BubbleTail = styled.div`
  position: absolute;
  top: 24px; /* 중간쯤 */
  left: -12px;
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-right: 12px solid #000;
`;

const Message = styled.div`
  font-size: 14px;
  line-height: 20px;
  white-space: pre-line;
`;

const ConfirmButton = styled.button`
  margin-top: 12px;
  margin-left: auto;
  display: block;
  background-color: var(--dk-bg, white);
  color: #c187d6;
  border: 1px solid #c187d6;
  border-radius: 8px;
  padding: 4px 12px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
`;
